import { render, staticRenderFns } from "./RegistrationAddress.vue?vue&type=template&id=25dace44&"
import script from "./RegistrationAddress.vue?vue&type=script&lang=js&"
export * from "./RegistrationAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25dace44')) {
      api.createRecord('25dace44', component.options)
    } else {
      api.reload('25dace44', component.options)
    }
    module.hot.accept("./RegistrationAddress.vue?vue&type=template&id=25dace44&", function () {
      api.rerender('25dace44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/RegistrationAddress.vue"
export default component.exports